export { ViewPricing } from './src/view-pricing';
